import { render, staticRenderFns } from "./AccountsCreateUser.vue?vue&type=template&id=703019cb&scoped=true"
import script from "./AccountsCreateUser.vue?vue&type=script&lang=js"
export * from "./AccountsCreateUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "703019cb",
  null
  
)

export default component.exports